import React, { Component, Fragment } from "react";
import NomeUnidade from "../../../../UI/NomeUnidade";
import Form from "../Form";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            user: {},
        }
    }

    render() {
        let unidade = this.props.match.params.unidade;
        return (
            <Fragment>
                <NomeUnidade unidade={unidade}/>
                <div className="content">
                    <Form unidade={unidade}/>
                </div>
            </Fragment>
        )
    }
}